"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _get = _interopRequireDefault(require("lodash/get"));
var _useTranslation = _interopRequireDefault(require("../../../i18n/useTranslation"));
var _Modal = require("../../Modal");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
var _useFetchServiceLimits = _interopRequireDefault(require("./useFetchServiceLimits"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useValidateItemCount = () => {
  const {
    itemCount,
    reportService
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const serviceLimits = (0, _useFetchServiceLimits.default)(reportService);
  const {
    onOpen
  } = (0, _react.useContext)(_Modal.ModalContext);
  const {
    T
  } = (0, _useTranslation.default)();
  return showValidateItemCountModalIfNeeded({
    onOpen,
    itemCount,
    serviceLimits,
    T
  });
};
const showValidateItemCountModalIfNeeded = _ref => {
  let {
    onOpen,
    itemCount,
    serviceLimits,
    T
  } = _ref;
  return _ref2 => {
    let {
      template,
      format
    } = _ref2;
    const formatName = format?.toLowerCase();
    const itemLimit = (0, _get.default)(serviceLimits, `${template}.limits.${formatName}`, Infinity);
    const isMultiPart = (0, _get.default)(serviceLimits, `${template}.multiPart`);
    const messageKey = isMultiPart ? 'multiPart' : 'singlePart';
    return new Promise(resolve => {
      if (itemCount > itemLimit) {
        onOpen({
          title: T.translate('limitsModal.title'),
          message: T.translate(`limitsModal.${messageKey}`, {
            itemLimit
          }),
          confirmationButtonLabel: T.translate('limitsModal.confirm'),
          cancelButtonLabel: T.translate('limitsModal.cancel'),
          onConfirm: () => resolve(true),
          onCancel: () => resolve(false)
        });
      } else {
        return resolve(true);
      }
    });
  };
};
var _default = exports.default = useValidateItemCount;